
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { endOfYear, subYears } from "date-fns";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { dateIsBefore } from "../../../../../../util/validacionesYup";
import FormikActions from "../../../../../commons/formik/FormikActions";
import FormikCheckbox from "../../../../../commons/formik/FormikCheckbox";
import FormikDatePicker from "../../../../../commons/formik/FormikDatePicker";
import CircularLoading from "../../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../../styled/Prevencion";

const maxInicioExposicion = endOfYear(subYears(new Date(), 1));

const InformarExamenesForm = ({ handleSubmit, initialValues, handleClose, open, examenesMedicos, fechaIngreso }) => {
  const informarExamenesValidation = Yup.object({
    inicioContacto: Yup.date()
      .nullable()
      .max(
        maxInicioExposicion,
        "La fecha de inicio de exposición no puede ser posterior al 31/12 del año anterior"
      )
      .test(
        "inicioNoMenorIngreso",
        "La fecha de inicio de exposición no puede ser anterior a la fecha de ingreso.",
        (value) => {
          if (!value || !fechaIngreso) {
            return true;
          }

          const inicio = new Date(value);
          const ingreso = new Date(fechaIngreso);
          return dateIsBefore(ingreso, inicio);
        }
      ),
  });

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        Informar Exámenes
      </DialogTitle>

      {
        examenesMedicos.length === 0 ?
          (
            <DialogContent >
              <CircularLoading />
            </DialogContent>
          )
          :
          (
            <Formik
              initialValues={initialValues}
              onSubmit={(values) => handleSubmit(values)}
              validationSchema={informarExamenesValidation}
              enableReinitialize
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <DialogContent>
                    <Grid container>
                      <StyledResolucion.DialogGridItem item xs={12}>
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                          <Grid item xs={6}>
                            <FormikDatePicker
                              name="inicioContacto"
                              label="Inicio de Exposición"
                              minDate={fechaIngreso ? new Date(fechaIngreso) : undefined}
                              maxDate={maxInicioExposicion}
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormikDatePicker
                              name="finContacto"
                              label="Fin de Exposición"
                              fullWidth
                            />
                          </Grid>
                        </Grid>
                        {
                          examenesMedicos.map((examen) => {
                            return (
                              <div key={examen.id.toString()}>
                                <FormikCheckbox
                                  key={examen.id.toString()}
                                  name={`${examen.id}.value`}
                                  label={examen.nombre}
                                />
                              </div>
                            )
                          })
                        }
                      </StyledResolucion.DialogGridItem>
                    </Grid>
                  </DialogContent>

                  <DialogActions>
                    <FormikActions handleCancel={handleClose} />
                  </DialogActions>
                </Form>
              )}
            </Formik>
          )
      }
    </Dialog>
  );
}

export default InformarExamenesForm;